"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("validation-errors", className, styles.root),
        error: styling_1.mergeStyles("validation-errors-error", styles.error),
        errorLabel: styling_1.mergeStyles("validation-errors-error-label", styles.errorLabel)
    };
});
exports.getClassNames = getClassNames;
